<template>
	<div class="container-facility">
		<ja-input
			v-model="facilityData.name"
			:disabled="!isEnable"
			:label="$t('name')"
			:name="$t('name')"
		></ja-input>
		<ja-textarea
			v-model="facilityData.description"
			class="text--bold-600"
			:disabled="!isEnable"
			:max-length="500"
			:label="$t('description')"
			:name="$t('description')"
		></ja-textarea>
		<ja-textarea
			v-model="facilityData.address"
			class="text--bold-600"
			:max-length="500"
			:disabled="!isEnable"
			:label="$t('address')"
			:name="$t('address')"
		></ja-textarea>
		<ja-input
			v-model="facilityData.zipCode"
			:disabled="!isEnable"
			:label="$t('zipCode')"
			:name="$t('zipCode')"
		></ja-input>
		<h2 class="heading-5">{{ $t('simulationType') }}</h2>
		<div class="container-input-checkbox">
			<div class="option">
				<div
					v-for="(option, index) in printShoppingTemplatesOptions"
					:key="index"
					class="option"
				>
					<input
						:id="option.name"
						ref="checkbox"
						v-model="option.isActive"
						type="checkbox"
						class="checkbox"
						:disabled="!isEnable"
						@change="handleCheckboxChange(index)"
					/>
					<label :for="option.name" class="body-text-2 input-label">
						{{ option.name }}
					</label>
				</div>
			</div>
		</div>
		<h2 class="heading-5">{{ $t('calculation') }}</h2>
		<div class="container-input-checkbox">
			<div class="option">
				<input
					id="NMICalculationRequired"
					v-model="facilityData.isNMICalculated"
					type="checkbox"
					class="checkbox"
					:disabled="!isEnable"
				/>
				<label for="NMICalculationRequired" class="body-text-2 input-label">
					{{ $t('NMICalculationRequired') }}
				</label>
				<input
					id="SavingsCalculationIsMandatory"
					v-model="facilityData.isAutoCalculated"
					type="checkbox"
					class="checkbox"
					:disabled="!isEnable"
				/>
				<label
					for="SavingsCalculationIsMandatory"
					class="body-text-2 input-label"
				>
					{{ $t('savingsCalculationIsMandatory') }}
				</label>
			</div>
		</div>
		<div v-if="facilityData.printShoppingTemplates">
			<h2 class="heading-5">{{ $t('LifestyleGoalQuestionsForPaperBased') }}</h2>
			<div class="container-input-checkbox">
				<div class="option">
					<input
						id="startOfSimulation"
						v-model="facilityData.includeLifestyleGoalOnStart"
						type="checkbox"
						class="checkbox"
						:disabled="!isEnable"
					/>
					<label for="startOfSimulation" class="body-text-2 input-label">
						{{ $t('startOfSimulation') }}
					</label>
					<input
						id="IsAtEndOfSimulation"
						v-model="facilityData.includeLifestyleGoalOnEnd"
						type="checkbox"
						class="checkbox"
						:disabled="!isEnable"
					/>
					<label for="IsAtEndOfSimulation" class="body-text-2 input-label">
						{{ $t('endOfSimulation') }}
					</label>
				</div>
			</div>
			<div class="container-input-checkbox">
				<div class="option">
					<input
						v-model="facilityData.printShoppingTemplates"
						name="printShoppingTemplates"
						type="checkbox"
						class="checkbox"
						:disabled="!isEnable"
					/>
					<label for="IsAtEndOfSimulation" class="body-text-2 input-label">
						{{ $t('printShoppingTemplatesDuringSimulation') }}
					</label>
				</div>
			</div>
		</div>
		<!-- //TODO: verify  -->
		<div v-if="false">
			<ja-dropdown
				v-model="studentEnrollmentRangeIndex"
				:label="$t('StudentEnrollmentRange')"
				:options="studentEnrollmentRangeOptions"
				name="StudentEnrollmentRange"
			></ja-dropdown>
			<ja-dropdown
				v-model="marketSizeIDIndex"
				:label="$t('marketSize')"
				:options="marketSizeIDOptions"
				name="marketSize"
			></ja-dropdown>
			<ja-dropdown
				v-model="implementationTypeIDIndex"
				:label="$t('implementationTypeID')"
				:options="implementationTypeIDOptions"
				name="implementationTypeID"
			></ja-dropdown>
		</div>
		<div class="container-buttons save">
			<ja-button
				v-if="isEnable"
				name="save"
				class="small outlined"
				:disabled="!isSaveCareer"
				@click.native="saveFacilityData"
				>{{ $t('save') }}</ja-button
			>
			<ja-button
				v-if="isEnable"
				name="cancel"
				class="small"
				@click.native="cancel"
				>{{ $t('cancel') }}</ja-button
			>
		</div>
	</div>
</template>
<script>
import { Dropdown, Input, Textarea } from '@/components/ui/form';
import Button from '@/components/ui/Button';
import AdminFacility from '@/mixins/AdminFacility';
import {
	printShoppingTemplates,
	studentEnrollment,
	marketSize,
	implementationType
} from '@/helpers/constants';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';

export default {
	components: {
		jaTextarea: Textarea,
		jaDropdown: Dropdown,
		jaButton: Button,
		jaInput: Input
	},
	mixins: [AdminFacility],
	props: {
		dataEdit: {
			type: Object,
			default: null,
			required: false
		}
	},
	data() {
		return {
			facilityData: {},
			studentEnrollmentRangeIndex: 0,
			implementationTypeIDIndex: 0,
			marketSizeIDIndex: 0,
			studentEnrollmentRangeOptions: studentEnrollment,
			implementationTypeIDOptions: implementationType,
			marketSizeIDOptions: marketSize,
			printShoppingTemplatesOptions: printShoppingTemplates
		};
	},
	computed: {
		isSaveCareer() {
			return (
				this.facilityData.name !== null &&
				this.facilityData.description !== null &&
				this.facilityData.address !== null &&
				this.facilityData.zipCode !== null
			);
		},
		isEnable() {
			return (
				(this.isSuperAdmin || this.isSuperAdmin) && this.selectedFacilityId == 0
			);
		}
	},
	watch: {
		marketSizeIDIndex(newValue) {
			this.facilityData.marketSizeID = this.marketSizeIDOptions[newValue].value;
		},
		implementationTypeIDIndex(newValue) {
			this.facilityData.implementationTypeID = this.implementationTypeIDOptions[
				newValue
			].value;
		},
		studentEnrollmentRangeIndex(newValue) {
			this.facilityData.studentEnrollmentRangeID = this.studentEnrollmentRangeOptions[
				newValue
			].value;
		},
		dataEdit(value) {
			if (value) {
				this.facilityData = this.dataEdit;
				this.setInitialIndexes();
			}
		}
	},
	mounted() {
		this.facilityData = this.dataEdit;
		this.setInitialIndexes();
	},
	methods: {
		setInitialIndexes() {
			this.printShoppingTemplatesOptions.forEach(print => {
				if (print.value === this.facilityData.printShoppingTemplates) {
					print.isActive = true;
				}
			});
			if (this.facilityData.description === null) {
				this.facilityData.description = '';
			}
		},
		handleCheckboxChange(index) {
			const checkbox = this.$refs.checkbox[index];

			this.printShoppingTemplatesOptions.forEach((sim, i) => {
				sim.isActive = i === index;
			});

			this.facilityData.printShoppingTemplates = this.printShoppingTemplatesOptions[
				index
			].value;
			if (
				checkbox.checked === false &&
				this.printShoppingTemplatesOptions[index].isActive == true
			) {
				this.$nextTick(() => {
					if (checkbox) {
						checkbox.checked = true;
					}
				});
				return;
			}
		},
		saveFacilityData() {
			this.$emit('saveFacility', this.facilityData);
		},
		cancel() {
			this.$emit('cancel');
		}
	}
};
</script>
<style lang="scss" scoped>
.container-facility {
	display: flex;
	flex-direction: column;
	gap: 20px;
}
.container-buttons {
	margin: 15px 0 10px 0;
	display: flex;
	align-items: center;
	gap: 20px;
}
.save {
	justify-content: flex-end;
}
.input-label {
	cursor: pointer;
	margin-right: 30px;
}
.heading-5 {
	color: $font-dark;
}
.text-button {
	color: $link-font-color;
}
.container-input-checkbox {
	border: 1px solid $button-border;
	display: flex;
	justify-content: space-between;
	padding: 12px;
}
.option {
	display: flex;
	align-items: center;
	gap: 10px;
}
</style>
